export const BASE_PATH = "/";

// NOTE: the campus login URL is served dynamically via the settings API
// (settingData.campus_login_url) - do not reintroduce a hardcoded constant.
//
// Environment-driven so a deploy never needs this file edited. Create React App
// inlines REACT_APP_* at build time and loads .env.production automatically for
// `npm run build`, and .env.local for `npm start`. The fallbacks are the
// PRODUCTION values, so a build with no env file configured is still correct.
export const API_URL = process.env.REACT_APP_API_URL || "https://api.vedcool.com/api";

// Object storage (Azure Blob).
//
// Storage moved from AWS S3 to Azure. Object keys were preserved byte-for-byte
// in the migration, so only the base URL changed and every key already stored
// in the database keeps resolving.
//
// Helpers and constants were renamed off the S3 vocabulary once the cutover
// was verified; only AZURE_BLOB_URL names a provider now.
export const AZURE_BLOB_URL =
    process.env.REACT_APP_AZURE_BLOB_URL || "https://stvedcool.blob.core.windows.net/public";

// The environment segment inside the object key: vc/<env>/frontend/...
// NOTE: this is "development" in production too - that is what the migrated
// blobs are actually stored under. Do not change it without moving the blobs.
export const ASSET_ENV = process.env.REACT_APP_ASSET_ENV || "development";

export const ASSET_BASE_URL = `${AZURE_BLOB_URL}/vc/${ASSET_ENV}/frontend`;
export const ASSET_DYNAMIC_BASE_URL = AZURE_BLOB_URL;

export const ASSET_HOMEPAGE_IMAGE_PATH = "homepage/";
export const ASSET_ABOUT_IMAGE_PATH = "aboutpage/";
export const ASSET_TEAM_IMAGE_PATH = "teams/";
export const ASSET_PRODUCTS_IMAGE_PATH = "products/";